export default __webpack_public_path__ + "static/media/lifong04.ed54c986.png";